import { useTheme } from '@mui/material';
import { styleConstants } from '../../../Utils/styleConsts';
export const useStyles = () => {
    const theme = useTheme();
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            marginTop: theme.spacing(2),
            maxWidth: '36rem',
            backgroundColor: theme.palette.background.paper,
            borderRadius: styleConstants.borderRadius,
            paddingTop: theme.spacing(1),
            '& > *:not(hr)': {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
            },
            [theme.breakpoints.down('sm')]: {
                maxWidth: '100%',
                '& > *:not(hr)': {
                    paddingLeft: theme.spacing(1),
                    paddingRight: theme.spacing(1),
                },
            },
        },
        title: {
            color: theme.palette.primary.dark,
        },
        breadcrumb: {
            display: 'flex',
            alignItems: 'center',
            color: theme.palette.primary.main,
        },
        breadcrumbText: {
            color: theme.palette.primary.dark,
            padding: '0 0 0.25em',
            lineHeight: '1em',
        },
        row: {
            display: 'flex',
            padding: `${theme.spacing(1.5)}`,
            '&:nth-of-type(even)': {
                backgroundColor: theme.palette.grey[100],
            },
            '& > *': {
                width: '50%',
                '&:first-of-type': {
                    fontWeight: 900,
                },
            },
        },
        printContainer: {
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
            marginBottom: theme.spacing(1),
            '@media print': {
                display: 'none',
            },
        },
        button: {
            textTransform: styleConstants.buttonTextTransform,
            fontSize: styleConstants.buttonFontSize,
            fontWeight: styleConstants.buttonFontWeight,
            padding: styleConstants.buttonPadding,
        }
    };
};
